var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9282e-05 14.9578C0.0131755 6.68247 6.73884 -0.0187552 15.0122 3.94379e-05C23.3063 0.0188341 30.0122 6.7257 30 14.9869C29.9869 23.3035 23.2913 30.0104 15.0085 30.0038C6.70783 29.9972 -0.013137 23.2584 1.9282e-05 14.9578ZM14.9812 27.0164C18.0814 26.9647 20.785 25.9338 23.0855 23.8589C23.2838 23.6794 23.3232 23.5394 23.2029 23.2969C21.5171 19.8979 18.79 18.026 14.9916 18.0382C11.1941 18.0504 8.4764 19.9355 6.8112 23.3449C6.69655 23.5789 6.74541 23.7085 6.9296 23.8739C9.22537 25.9319 11.9205 26.9553 14.9822 27.0164H14.9812ZM19.506 10.4865C19.5023 8.01031 17.4856 6.00117 15 5.99741C12.5379 5.99365 10.4968 8.03569 10.5006 10.4978C10.5043 12.9806 12.5201 15.0019 14.9925 15.001C17.4931 15.001 19.5098 12.9824 19.506 10.4856V10.4865Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUser);
export default __webpack_public_path__ + "static/media/newUser.3d06fa5f3ce24c98c8c29667e7776efa.svg";
export { ForwardRef as ReactComponent };